export default function LoadingOverlay() {
  return (
    <div className="loading-wrapper">
      <div className="bird">
        <div className="hair-container">
          <div className="hair"></div>
        </div>
        <div className="face">
          <div className="white-container">
            <div className="white"></div>
          </div>
          <div className="shadow-container">
            <div className="shadow"></div>
          </div>
          <div className="bigBeak-container">
            <div className="bigBeak"></div>
          </div>
          <div className="smallBeak-container">
            <div className="smallBeak"></div>
          </div>
          <div className="eye"></div>
        </div>
      </div>
    </div>
  );
}
